module.exports = __webpack_public_path__ + "img/con1-2y.1b12ca9f.png";